import { render, staticRenderFns } from "./filterCom.vue?vue&type=template&id=1d989a34&scoped=true"
import script from "./filterCom.vue?vue&type=script&lang=js"
export * from "./filterCom.vue?vue&type=script&lang=js"
import style0 from "./filterCom.vue?vue&type=style&index=0&id=1d989a34&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d989a34",
  null
  
)

export default component.exports